import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { PaymentMethod, PaymentMethodService } from '@galaxy/billing';
import { ReplaySubject, firstValueFrom } from 'rxjs';
import { SelectedPaymentMethod } from '../payment-method';
import { MatDialog } from '@angular/material/dialog';
import { AsyncPipe, NgIf } from '@angular/common';
import { PaymentMethodSelectorComponent } from '../payment-method-selector/payment-method-selector.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  imports: [AsyncPipe, NgIf, TranslateModule, PaymentMethodSelectorComponent],
  selector: 'smb-invoicing-default-payment-method-selector',
  templateUrl: './default-payment-method-selector.component.html',
  styleUrls: ['./default-payment-method-selector.component.scss'],
})
export class DefaultPaymentMethodSelectorComponent implements OnInit {
  @Input() stripeKey: string;
  @Input() merchantId: string;
  @Input() customerId: string;
  @Input() stripeConnectId: string;
  @Input() hintText: string;
  @Input() emptyCardHintText: string;
  @Input() submitDialogText: string;
  @Input() isEditable = true;
  @Input() saveCardAsDefault = true;
  @Input() canRemoveSelectedMethod: boolean;
  @Input() showAllMethods: boolean;

  @Output() paymentMethodSelected: EventEmitter<boolean> = new EventEmitter<boolean>();

  defaultPaymentMethod$$ = new ReplaySubject<PaymentMethod>(1);
  loadingPaymentMethods$$ = new ReplaySubject<boolean>(1);
  paymentMethods$$ = new ReplaySubject<PaymentMethod[]>(1);

  constructor(
    public dialog: MatDialog,
    private paymentMethodService: PaymentMethodService,
  ) {}

  ngOnInit(): void {
    this._listPaymentMethods();
  }

  async selectPaymentMethod(paymentMethod: SelectedPaymentMethod): Promise<void> {
    const selectedPaymentMethodId = paymentMethod?.paymentMethodId;
    await firstValueFrom(
      this.paymentMethodService.setDefaultPaymentCard(this.merchantId, this.customerId, selectedPaymentMethodId),
    );
    await this._listPaymentMethods();
    this.paymentMethodSelected.emit(true);
  }

  private async _listPaymentMethods(): Promise<void> {
    this.loadingPaymentMethods$$.next(true);
    const paymentMethods = await firstValueFrom(this.paymentMethodService.list(this.merchantId, this.customerId));
    this.paymentMethods$$.next(paymentMethods);
    const defaultPaymentMethod = (paymentMethods || []).find((method) => method?.default);
    this.defaultPaymentMethod$$.next(defaultPaymentMethod);
    this.loadingPaymentMethods$$.next(false);
  }
}
